import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Calendar, Clock, MapPin } from 'lucide-react';

const EventInfoCard = ({ event, duration }) => {
  return (
    <Card className="bg-gradient-to-r from-blue-50 to-indigo-50 border-blue-200">
      <CardContent className="p-4">
        <h3 className="font-bold text-lg text-slate-900 mb-3">{event.titre}</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
          <div className="flex items-center gap-2">
            <Calendar className="w-4 h-4 text-blue-600" />
            <span>{event.date}</span>
          </div>
          <div className="flex items-center gap-2">
            <Clock className="w-4 h-4 text-blue-600" />
            <span>{event.heure_debut} - {event.heure_fin}</span>
          </div>
          <div className="flex items-center gap-2">
            <MapPin className="w-4 h-4 text-blue-600" />
            <span>{event.zone_geographique || 'N/A'}</span>
          </div>
          <div className="flex items-center gap-2">
            <Clock className="w-4 h-4 text-blue-600" />
            <span>Durée: {duration}</span>
          </div>
        </div>
        {event.type_atelier && (
          <Badge className="mt-3 bg-blue-100 text-blue-700">
            {event.type_atelier.replace(/_/g, ' ')}
          </Badge>
        )}
      </CardContent>
    </Card>
  );
};

export default EventInfoCard;
